export default __webpack_public_path__ + "static/media/ally_xl3.655badb2.png";